/**
 * ActionRow — bottom action panel for Video Viewer.
 *
 * Mirrors PhotoViewer ActionRow:
 *   1. Скачать — gradient #ffc24c→#ff9012, flex-1
 *   2. Поделиться — glass-16, flex-1
 *   3. Recreate — glass-16, 48×48, direct tap → repeat generation
 */
import { useTranslation } from 'react-i18next';
import { Icon } from '../../primitives';

export default function ActionRow({ onDownload, onShare, onRepeat }) {
  const { t } = useTranslation();
  return (
    <div
      className="flex items-center gap-2"
      style={{ height: 48, width: '100%' }}
      data-testid="action-row"
    >
      {/* Скачать — gradient button */}
      <button
        type="button"
        onClick={onDownload}
        className="flex-1 flex items-center justify-center gap-1.5 rounded-home-24 font-sans font-bold text-text-inverse bg-download-btn-gradient"
        style={{
          height: 48,
          fontSize: 14,
          lineHeight: '16.436px',
        }}
        aria-label={t('common.download')}
        data-testid="action-download"
      >
        <Icon name="download" size={20} className="text-text-inverse" />
        <span>{t('common.download')}</span>
      </button>

      {/* Поделиться — glass button */}
      <button
        type="button"
        onClick={onShare}
        className="flex-1 flex items-center justify-center gap-1.5 rounded-home-24 font-sans font-bold text-text-primary backdrop-blur-secondary-btn bg-glass-16"
        style={{
          height: 48,
          fontSize: 14,
          lineHeight: '16.436px',
        }}
        aria-label={t('common.share')}
        data-testid="action-share"
      >
        <img src="/icons/telegram.svg" width={20} height={20} alt="" aria-hidden="true" />
        <span>{t('common.share')}</span>
      </button>

      {/* Recreate — glass square 48×48, direct repeat-generation tap */}
      <button
        type="button"
        onClick={onRepeat}
        className="flex items-center justify-center rounded-home-24 text-text-primary backdrop-blur-secondary-btn bg-glass-16"
        style={{
          width: 48,
          height: 48,
          flexShrink: 0,
        }}
        aria-label={t('common.repeat')}
        data-testid="action-recreate"
      >
        <Icon name="recreate" size={20} className="text-text-primary" />
      </button>
    </div>
  );
}
